import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalCadastrarPlanoRecuperacaoJudicialComponent } from './modal-cadastrar-plano-recuperacao-judicial/modal-cadastrar-plano-recuperacao-judicial.component';
import { Subject } from 'rxjs';
import { ResultadoModal } from 'src/app/services/shared/resultado-modal';
import { Guid } from 'guid-typescript';
import { PlanoRecuperacaoJudicialService } from 'src/app/services/plano-recuperacao-judicial.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-plano-recuperacao-judicial',
    templateUrl: './plano-recuperacao-judicial.component.html',
    styleUrls: ['./plano-recuperacao-judicial.component.scss']
})
export class PlanoRecuperacaoJudicialComponent implements OnInit {

    @Input() processoJudicialId: Guid;
    @Input() recursoDesdobramentoId: Guid;

    public loading: boolean = true;

    public raiz: string = '';

    public prjs: any[];

    resultConfirmDialog$ = new Subject<ResultadoModal>();

    constructor(
        private router: Router,
        private ngbModal: NgbModal,
        private planoRecuperacaoJudicialService: PlanoRecuperacaoJudicialService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
    ) { }

    ngOnInit(): void {
        if (this.router.url.indexOf('/dashboard/') > -1) {
            this.raiz = '/dashboard'
        } else {
            this.raiz = '/operacionais'
        }

        this.obterPlanosRecuperacaoJudicial();
    }

    obterPlanosRecuperacaoJudicial() {        
        
        // this.planoRecuperacaoJudicialService.obterPorRecursoDescobramento(this.recursoDesdobramentoId)
        //     .subscribe(res=>{
        //         this.loading = false;
        //         this.prjs = res.data;
        //     }, err=>{
        //         this.toastrService.error(' Erro ao carregar planos de recuperação')
        //     })                
        this.loading = false;
        this.prjs = [];
    }

    cadastrarPlanoRecuperacaoJudicial() {
        const modalRef = this.ngbModal.open(ModalCadastrarPlanoRecuperacaoJudicialComponent
            , {
                size: 'md',
                backdrop: 'static',
                keyboard: false
            });

        modalRef.componentInstance.modalRef = modalRef;
        modalRef.result.then(result => {
            this.resultConfirmDialog$.next(result);
            this.obterPlanosRecuperacaoJudicial();
        }).catch(error => { });
    }

}
